// Function to check if the customer has the "wholesale" tag
function hasWholesaleTag(customerTags) {
  return customerTags.includes('wholesale');
}

// Function to redirect the customer to the wholesale shop page
function redirectToWholesaleShop() {
  window.location.href = '/pages/wholesale';
}

// Function to handle customer login event
function handleCustomerLogin(event) {
  var customer = event.detail.customer;

  // Check if the customer has the "wholesale" tag
  if (customer && hasWholesaleTag(customer.tags)) {
    redirectToWholesaleShop();
  }
}

// Listen for customer login event
document.addEventListener('shopify:customer:login', handleCustomerLogin);